import { useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import Button from "../../../components/Buttons/button";
import Card from "../../../components/card/feedbackerCards/card";
import BasicModal from "../../../components/models/models";
import Header from "../../../components/Headers/Header";
import savingIcon from "../../../assets/icons/fluent_savings.svg";
import chevronIcon from "../../../assets/icons/chevron_down.svg";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useFormattedAmount } from "../../../hooks/useFormattedAmount";
import { savingsOpportunities } from "../../../services/servicesData";
import SavingOpportunity from "../../../components/opportunity/SavingOpportunity";
import { selectUser } from "../../../redux/slices/userSlice";
import {
  getServicesRequest,
  selectPersonalDashboard,
  getSavingOpportunity,
  updateSubmissionData,
} from "../../../redux/slices/personalDashboardSlice";
import { selectCompanyDashboard } from "../../../redux/slices/companyDashboardSlice";

function ServicesModule({ show, setShow }) {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const formatFunction = useFormattedAmount();
  const [popup, setPopup] = useState(false);
  const [state, setState] = useState(0);
  const [cost, setCost] = useState(null);
  const [id, setId] = useState("");
  const [billingPeriod, setBillingPeriod] = useState();
  const [toggle, setToggle] = useState(false);
  const [serviceType, setServiceType] = useState("");

  const UserState = useSelector(selectUser);
  const { userDetails } = UserState;
  const State = useSelector(selectPersonalDashboard);
  const CompanyState = useSelector(selectCompanyDashboard);
  const { servicesData, savingOpportunityData } = State;
  const { opportunityStatusId } = CompanyState;
  const { historyData } = State || {};
  const { CompanyhistoryData } = CompanyState || {};
  const billingPeriodMonth = servicesData?.custom_billing_period?.month || userDetails.user?.active_billing_period 
  const custom_billing_period_id = servicesData?.custom_billing_period?.id

  const titleContent = (
    <>
      {billingPeriodMonth == null ? (
        <Skeleton width={250} inline />
      ) : (
        <>Your Services ({billingPeriodMonth})</>
      )}
    </>
  );

  const subHeadingContent = (
    <>
      Billing Period:{" "}
      {billingPeriod == null
        ? <Skeleton width={100} inline />
        : `${billingPeriod?.month}, ${billingPeriod?.year}`}
    </>
  );

  // useEffect(() => {
  //   if (localStorage.getItem("manageServiceId")) {
  //     setPopup(true);
  //     setState(35);
  //     setId(localStorage.getItem("manageServiceId"));
  //     localStorage.removeItem("manageServiceId");
  //   }
  // }, []);

  const handleInput = (field, value) => {
    dispatch(updateSubmissionData({ field, value }));
  };

  useEffect(() => {
    if (custom_billing_period_id) {
      dispatch(getServicesRequest(custom_billing_period_id));
    } else {
      dispatch(getServicesRequest(null));
    }
  }, [dispatch, custom_billing_period_id]);

  useEffect(() => {
    setBillingPeriod(servicesData?.billing_period);
  }, [servicesData]);

  useEffect(() => {
    if (userDetails?.user) {
      dispatch(getSavingOpportunity(userDetails?.user?.id, "emp_id"));
    }
  }, [userDetails?.user, opportunityStatusId]);

  useEffect(() => {
    if (historyData && CompanyhistoryData) {
      const dataToUse = pathname.includes("personal_dashboard")
        ? historyData?.total_monthly_cost
        : CompanyhistoryData?.total_monthly_cost;
      setCost(dataToUse);
    }
  }, [pathname, historyData, CompanyhistoryData]);

  return (
    <div
      onClick={() => {
        setShow(true);
      }}
      className="right_panel w-full max-w-full lg:pl-[24px] xl:pl-0 flex flex-col gap-3 md:gap-6 lg:gap-8 px-[0] lg:pt-1 xl:max-w-[1099px] 6xl:max-w-[80%] h-screen lg:pr-[24px]"
    >
      <SkeletonTheme baseColor="#3B4255" highlightColor="#0000001a">
        <Header
          title={titleContent}
          subHeading={subHeadingContent}
          setShow={setShow}
          show={show}
          btns
        />
      </SkeletonTheme>

      <div className="h-auto flex gap-3 md:gap-6 lg:gap-8 px-3 md:px-0 flex-col overflow-y-scroll scrollbar-hide">
        <div className="flex gap-1 m-1 sm:gap-[20px] justify-between sm:justify-end items-center md:hidden">
          <Button
            onClick={() => {
              setPopup(true);
              setState(3);
              handleInput("type", "MissingSubmission");
              setServiceType("missingService");
            }}
            secondary={true}
            hoverColor={true}
            fill={false}
            position={"center"}
            className=" btnHover !w-[fit-content]"
          >
            Missing service
          </Button>
          <Button
            onClick={() => {
              setPopup(true);
              setState(1);
              handleInput("type", "NewSubmission");
              setServiceType("newService");
            }}
            hoverColor={true}
            fill={true}
            position={"center"}
            onMouseEnter={() => {
              setToggle(!toggle);
            }}
            onMouseLeave={() => {
              setToggle(toggle && !toggle);
            }}
            className=" btnHover !w-[fit-content]"
          >
            New service
          </Button>
        </div>

        {!pathname.includes("tasker") && (
          <SkeletonTheme baseColor="#3B4255" highlightColor="#0000001a">
            <div className="p-3 md:p-[24px] rounded-[12px] md:rounded-[24px] lg:rounded-[32px] bg-grey-blue-700 flex justify-between items-center flex sm:hidden">
              <div className="flex flex-col gap-[6px]">
                {cost !== undefined && (
                  <span className="text-primary !text-[20px]">
                    {formatFunction(cost ? cost : 0)}
                  </span>
                )}
                {cost === undefined && (
                  <span className="text-primary !text-[20px] w-[130px]">
                    <Skeleton />
                  </span>
                )}
                {cost !== undefined && (
                  <span className="text-secondary">
                    {pathname.includes("personal_dashboard")
                      ? "Your monthly cost"
                      : "Total monthly cost"}
                  </span>
                )}
                {cost === undefined && (
                  <span className="text-secondary w-[130px]">
                    <Skeleton />
                  </span>
                )}
              </div>
              <div className="flex justify-center items-center">
                <Button
                  onClick={() => {
                    setPopup(true);
                    setState(11);
                  }}
                  fill={false}
                  secondary={true}
                  hoverColor={true}
                >
                  History
                </Button>
              </div>
            </div>
          </SkeletonTheme>
        )}

        {savingOpportunityData?.savings_opportunities?.length > 0 && (
          <SavingOpportunity
            opportunity={savingOpportunityData}
            userId={userDetails?.user?.id}
            companyName={userDetails?.user?.company_name}
          />
        )}

        <div className="card-section">
          <div
            className={`cards_wrap inner_space flex flex-wrap gap-[12px] md:gap-[24px] lg:gap-[32px] justify-start pb-[20px] overflow-y-scroll scrollbar-hide ${
              savingOpportunityData?.savings_opportunities?.length > 0
                ? "!h-auto sm:!h-[calc(100vh-316px)] md:!h-[calc(100vh-270px)]"
                : "!h-auto sm:!h-[calc(100vh-171px)] md:!h-[calc(100vh-130px)]"
            }`}
          >
            {servicesData?.services &&
              servicesData.services
                ?.filter((each) => each.name !== "Personal Expenses")
                .map((service, index) => (
                  <Card
                    state={state}
                    popup={popup}
                    setPopup={setPopup}
                    setState={setState}
                    modalId={service.id}
                    servicesData={servicesData}
                    key={index}
                    image={service.image_url}
                    title={service.name}
                    price={formatFunction(service.cost_per_month)}
                    rating={service.rating}
                    btns={true}
                    navLink={`/personal_dashboard/services/usage_report/${service.id}`}
                    userDetails={userDetails}
                  />
                ))}
          </div>
        </div>
      </div>

      {setPopup && (
        <BasicModal
          state={state}
          popup={popup}
          setPopup={setPopup}
          setState={setState}
          serviceType={serviceType}
          id={id}
          setId={setId}
        />
      )}
    </div>
  );
}

export default ServicesModule;
